<template>
  <v-overlay :value="computedVisible">
    <v-carousel
      v-model="computedIndex"
      style="min-width: 50vw; max-width: 90vw; border-radius: 5px"
      :show-arrows="items.length > 1 ? true : false"
      :hide-delimiters="items.length > 1 ? false : true"
      class="carousel_image"
      v-click-outside="closeLightbox"
      @change="onPhotoSwipe"
      height="90vh"
    >
      <v-zoomer
        ref="zoomer"
        :zoomed.sync="isZoomed"
        :mouseWheelToZoom="enableZoom"
        :doubleClickToZoom="enableZoom"
        style="width: 100%; height: 100%; background-color: rgba(0,0,0,0.7)"
      >
        <v-carousel-item v-for="(photoSrc, idx) in items" :key="idx">
          <div style="width: auto; height: auto">
            <v-img :src="photoSrc" contain max-height="90vh" max-width="90vw" style="outline: 1px solid transparent">
              <template #placeholder>
                <main-loader color="white" />
              </template>
            </v-img>
          </div>
        </v-carousel-item>
      </v-zoomer>
      <v-row style="position: absolute; top: 1.5rem; right: 1.5rem; gap: 0.5rem">
        <v-btn
          v-if="enableZoom && isZoomed"
          class="pa-0"
          color="rgba(255,255,255,0.5)"
          height="30"
          width="30"
          min-width="30"
          depressed
          rounded
          @click="resetZoom"
        >
          <v-icon color="rgba(0,0,0,0.6)" small>mdi-arrow-expand</v-icon>
        </v-btn>
        <v-btn
          class="pa-0"
          color="rgba(255,255,255,0.5)"
          height="30"
          width="30"
          min-width="30"
          depressed
          rounded
          @click="computedVisible = false"
        >
          <v-icon color="rgba(0,0,0,0.6)" small>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-carousel>
  </v-overlay>
</template>

<script>
import VueZoomer from 'vue-zoomer';
import MainLoader from '@/components/MainLoader';

export default {
  name: 'ImageLightbox',
  components: {
    VZoomer: VueZoomer.Zoomer,
    MainLoader,
  },
  data: () => ({
    isZoomed: false,
  }),
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    startPhotoIndex: {
      type: Number,
      default: 0,
    },
    enableZoom: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedVisible: {
      get() {
        return this.visible;
      },
      set(nV) {
        this.$emit('update:visible', nV);
      },
    },
    computedIndex: {
      get() {
        return this.startPhotoIndex;
      },
      set(nV) {
        this.$emit('update:startPhotoIndex', nV);
      },
    },
  },
  methods: {
    closeLightbox() {
      this.computedVisible = false;
    },
    async resetZoom() {
      await this.$nextTick();
      this.$refs.zoomer?.reset();
      this.isZoomed = false;
    },
    onPhotoSwipe() {
      this.resetZoom();
    },
  },
};
</script>

<style lang="scss" scoped>
// fix martwych pixeli na Chromie w tle przy przesuwaniu zdjęcia podczas zoomowania
::v-deep {
  .v-image__image {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
}
</style>
